<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Vos boutiques</h4>
        <p class="category">Voici la liste des boutiques que vous avez ajouté</p>
      </div>
      <div class="card-content row">
        <div class="col-sm-12">
          <el-table :data="stores">
            <el-table-column type="index">

            </el-table-column>
            <el-table-column prop="name"
                             label="Nom">
            </el-table-column>
            <el-table-column prop="address"
                             label="Adresse">
            </el-table-column>
            <el-table-column
              label="Actions">
              <template slot-scope="props">
                <a class="btn btn-simple btn-info btn-xs btn-icon view" @click="handleView(props.$index, props.row)"><i class="ti-eye"></i></a>
                <a class="btn btn-simple btn-warning btn-xs btn-icon edit" @click="handleEdit(props.$index, props.row)"><i class="ti-pencil-alt"></i></a>
                <a class="btn btn-simple btn-danger btn-xs btn-icon remove"  @click="handleDelete(props.$index, props.row)"><i class="ti-close"></i></a>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="card-footer">
        <button @click="$router.push({name: 'StoreAdd'})" class="btn btn-default btn-fill btn-wd btn-back">Ajouter</button>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import { mapGetters } from 'vuex'

  Vue.use(Table)
  Vue.use(TableColumn)
  export default{
    components: {
      PSwitch
    },
    computed: {
      ...mapGetters('stores', {
        stores: 'all'
      })
    },
    methods: {
      handleView (index, store) {
        console.log(store)
        this.$router.push({name: 'StoreView', params: {store_id: store._key}})
      },
      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },
      handleDelete (index, row) {
        alert(`Your want to delete ${row.name}`)
      },
      getSummaries (param) {
        const { columns } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = 'Total'
          } else if (index < columns.length - 1) {
            sums[index] = ''
          } else {
            let sum = 0
            this.productsTable.forEach((obj) => {
              sum += obj.quantity * obj.price
            })
            sums[index] = `€ ${sum}`
          }
        })
        return sums
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Company/Store/List.vue